export default __webpack_public_path__ + "static/media/beive_logo.e72f80fd.png";